<template>
    <div class="profile-tabs__wrapper profile-tabs__wrapper--volunteer profile-tabs__wrapper--volunteer-payments">

        <div class="profile-tabs">
            <div class="profile-tabs__header-text">Выплаты</div>

            <template v-if="array.length && loaded">
                <div class="profile-tabs__scroll-wrapper">
                    <div class="profile-tabs__body">

                        <div class="profile-tabs__body-item d-flex"
                             v-for="({target = null, expenditure, ...item}, index) in array" :key="index">

                            <template v-if="target && item">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-image" v-if="item.target_type.indexOf('Pet') >= 0">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-image" v-if="item.target_type.indexOf('Project') >= 0">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <div class="profile-tabs__body-info d-flex">
                                        <span>
                                            {{item.amount}} BYN
                                        </span>
                                        <template v-if="item.statusFront">
                                            <div v-html="item.statusFront"></div>
                                        </template>
                                    </div>

                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-name" v-if="item.target_type.indexOf('Pet') >= 0">{{ target.name }}</a>
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-name" v-if="item.target_type.indexOf('Project') >= 0">{{ target.name }}</a>
                                    <div v-if="item.ticket_url">
                                        <a title="Талон на ветеринарное обслуживание" class="profile-tabs__body-name" :href="item.ticket_url" target="_blank">
                                            <span class="lnr lnr-file-empty"></span>
                                            Талон на вет. обслуживание
                                        </a>
                                    </div>

                                    <div class="profile-tabs__body-meta">{{getNoticeDate(item.created_at)}}</div>
                                </div>
                            </template>

                        </div>

                    </div>
                </div>
            </template>
            <template v-else-if="!loaded">
                <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                    <div class="LoaderBalls">
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="profile-tabs__body profile-tabs__body--empty d-flex">

                    Список пуст

                </div>
            </template>


        </div>

    </div>
</template>

<script>

import Tabs from '../tabs/Tabs';
import Tab from '../tabs/Tab';

export default {
    name: "UserDashboardTabs",
    props: ['user'],
    components: {Tab, Tabs},
    data() {
        return {
            array: [],
            loaded: false,
        }
    },

    async mounted() {
        await this.getDonated()
    },

    methods: {

        async getDonated() {

            const params = {
                per_page: 20,
                page: 1,
            }

            try {
                const {data} = await axios.get( `/api/user/expenditure-requests`, { params: params } )
                this.array = data.data

                this.array = this.array.map((_item) => {

                    if( _item.status ){

                        switch ( _item.status ){
                            case 'created':
                                _item.statusFront =
                                    `<span class="profile-tabs__body-info-label created">Создан</span>`;
                                break;
                            case 'approved':
                                _item.statusFront =
                                    `<span class="profile-tabs__body-info-label approved">Одобрен</span>`;
                                break;
                            case 'rejected':
                                _item.statusFront =
                                    `<span class="profile-tabs__body-info-label rejected">Отклонен</span>`;
                                break;
                            case 'funded':
                            case 'processed':
                                _item.statusFront =
                                    `<span class="profile-tabs__body-info-label funded">Оплачен</span>`;
                                break;
                            default:
                                break;
                        }

                    }

                    return _item

                })

            } catch (e) {
                console.log(e)
            }
        },

        getNoticeDate(timestamp){
            let dateUTC = Date.parse(timestamp)
            let dateNow = Date.now()

            let minutes = ((dateNow - dateUTC ) / 1000 / 60).toFixed()


            if(minutes < 60) {

                minutes = (minutes <= 1) ? 'Сейчас' : (minutes > 1 && minutes < 5) ? `${minutes} минуты назад` : `${minutes} минут назад`;

            }else if(minutes >= 60 && minutes < 1440){

                minutes = +(minutes / 60).toFixed()
                minutes = (minutes <= 1) ?  `${minutes} час назад` : (minutes > 1 && minutes <  5) ? `${minutes} часа назад` : `${minutes} часов назад`;

            } else{

                minutes = +(minutes / 1440).toFixed()
                minutes = (minutes === 1) ?  `${minutes} день назад` : (minutes > 1 && minutes < 5) ? `${minutes} дня назад` : `${minutes} дней назад`

            }

            return minutes

        },

        getUserPM(name) {
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },

    watch: {
        array() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },


}
</script>

<style lang="scss" scoped>

.profile-tabs__body-name{
 .lnr{
     font-size: 14px;
 }
}

</style>
